import { render, staticRenderFns } from "./contactInfo.vue?vue&type=template&id=16d25b58&scoped=true"
import script from "./contactInfo.vue?vue&type=script&lang=js"
export * from "./contactInfo.vue?vue&type=script&lang=js"
import style0 from "./contactInfo.vue?vue&type=style&index=0&id=16d25b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d25b58",
  null
  
)

export default component.exports